import React from 'react'

export default function Users() {
  return (
    <div>
      Users page
    </div>
  )
}
